import TotalAvgShareOfShelfChart from "./TotalAvgShareOfShelfChart";
export default TotalAvgShareOfShelfChart;
